import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'

import {
  type FillApplicationState,
  IntakeRowStatus,
  invalidateFillApplication,
} from '@/models/fillApplication'

/** Changes whenever a file finishes, or a row stops being read (from any batch). */
function finishedKey(state: FillApplicationState): string {
  const done = (state.batch?.documents ?? [])
    .filter((document) => document.status === IntakeRowStatus.DONE)
    .map((document) => document.id)
    .sort()
  const reading = state.inFlight.map((row) => row.id).sort()
  return `${done.join(',')}|${reading.join(',')}`
}

/** Refetches what the cards show when the state poll sees a file finish; the poll itself keeps the state fresh. */
export function useRefreshOnFileFinished(orgId: string, state: FillApplicationState | undefined) {
  const queryClient = useQueryClient()
  const key = state ? finishedKey(state) : null
  const previous = useRef<string | null>(null)

  useEffect(() => {
    if (key === null) return
    if (previous.current !== null && previous.current !== key) {
      void invalidateFillApplication(queryClient, orgId, { state: false })
    }
    previous.current = key
  }, [key, orgId, queryClient])
}
